import './bootstrap'
import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store.js'
import Loading from 'vue-loading-overlay'
import VueTinyLazyloadImg from 'vue-tiny-lazyload-img'
import './mixin.js'

import './registerServiceWorker'
import './assets/sass/style.scss'
import 'vue-loading-overlay/dist/vue-loading.css';

// Component ==========================================
Vue.component('Toast', require('./components/Toast.vue').default)
Vue.component('ButtonLoader', require('./components/ButtonLoader.vue').default)
Vue.component('loading-app', require('./components/LoadingApp.vue').default)
Vue.component('action-sheet', require('./components/ActionSheet.vue').default)
Vue.component('action-sheet-sender', require('./components/ActionSheetSender.vue').default)
Vue.component('Dialog', require('./components/Dialog.vue').default)
Vue.component('Modal', require('./components/Modal.vue').default)
Vue.component('Loading', Loading)
Vue.component('privacy-policy', require('./components/PrivacyPolicy.vue').default)

// Filter ==========================================
Vue.filter('rupiah', function (value) {
  var val = parseInt(value)
  return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
})

Vue.use(VueTinyLazyloadImg);
Vue.config.productionTip = false
Vue.config.ignoredElements = [/^ion-/]

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')